module.exports = __webpack_public_path__ + "static/rooms2-38e11c9dec4f0d6bce2ce3b2dbcb469c.jpg";